<template>
  <div class="vld-parent" ref="rootElement">
    <div class="card">
      <div class="card-header">
        <template v-if="isUpdate">Update Patient</template>
        <template v-else>Register Patient</template>
      </div>
      <div class="card-body">
        <!-- basic information -->
        <form v-on:submit.prevent id="register-patient-form">
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="patient-id">Patient ID</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="patient-id"
                v-model="patient.patientId"
                v-bind:readOnly="isReadOnly"
                required
              />
            </div>
            <div class="form-group col-md-1">
              <label for="title">Title</label>
              <select id="title" class="form-control form-control-sm" v-model="patient.title">
                <option v-for="title in sortedTitles" v-bind:key="title">{{ title }}</option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label for="first-name">First Name</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="first-name"
                v-model="patient.firstName"
                required
              />
            </div>
            <div class="form-group col-md-3">
              <label for="last-name">Last Name</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="last-name"
                v-model="patient.lastName"
              />
            </div>
            <div class="form-group col-md-2">
              <label for="age">Age</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="age"
                v-model="patient.age"
              />
            </div>
            <div class="form-group col-md-1">
              <label for="gender">Gender</label>
              <select
                id="gender"
                class="form-control form-control-sm"
                v-model="patient.gender"
                required
                v-bind:disabled="genderSelectionDisabled"
              >
                <option selected></option>
                <option>M</option>
                <option>F</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="sample-collected-date">Sample Collected Date</label>
              <input
                type="date"
                class="form-control form-control-sm"
                id="sample-collected-date"
                v-model="patient.sampleCollectedOn"
                ref="sampleCollectedOn"
                required
              />
            </div>
            <div class="form-group col-md-3">
              <label for="tests">Tests</label>
              <select id="tests" class="form-control form-control-sm" v-model="testId">
                <option
                  v-for="test in tests"
                  v-bind:value="test.id"
                  v-bind:key="test.id"
                >{{ test.testName}}</option>
              </select>
            </div>
            <div class="form-group col-md-1">
              <label>&nbsp;&nbsp;</label>
              <button
                type="button"
                class="btn btn-blue btn-sm btn-100"
                v-on:click="addToPatientTests"
              >Add</button>
            </div>
            <div class="col-md-6">
              <span class="font-weight-bold">Tests :</span>
              <span>
                <span
                  v-for="test in selectedTests"
                  v-bind:key="test.id"
                  v-bind:disabled="isReadOnly"
                >
                  <span>
                    <TestSnippet v-bind:id="test.id" v-bind:name="test.testName" />
                  </span>
                </span>
              </span>
            </div>
          </div>
        </form>

        <!-- additional information -->

        <form v-on:submit.prevent>
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="requested-by">Requested By</label>
              <!-- <input type="text" class="form-control form-control-sm" id="requested-by" v-model="patient.requestedBy"> -->
              <input
                type="text"
                list="requestedBy"
                class="form-control form-control-sm"
                id="requested-by"
                v-model="patient.requestedBy"
              />
              <datalist id="requestedBy">
                <template v-for="value in allRequestedBy">
                  <option v-bind:value="value" v-bind:key="value">{{value}}</option>
                </template>
              </datalist>
            </div>
            <div class="form-group col-md-1">
              <label for="ward">Ward</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="ward"
                v-model="patient.ward"
              />
            </div>
            <div class="form-group col-md-2">
              <label for="contact-number">Contact</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="contact-number"
                v-model="patient.contactNumber"
              />
            </div>
            <div class="form-group col-md-2">
              <label for="email-address">Email address</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="email-address"
                v-model="patient.emailAddress"
              />
            </div>
            <div class="form-group col-md-2">
              <label for="nic">NIC</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="nic"
                v-model="patient.nic"
              />
            </div>
            <div class="form-group col-md-3">
              <label for="address">Address</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="address"
                v-model="patient.address"
              />
            </div>
            <div class="form-group col-md-2">
              <label for="collection-center">Collection Center</label>
              <!-- <input type="text" class="form-control form-control-sm" id="collection-center" v-model="patient.collectionCenter"> -->
              <select id="collection-center" class="form-control form-control-sm" v-model="patient.collectionCenter">
                <option
                  v-for="value in allCollectionCenters"
                  v-bind:value="value"
                  v-bind:key="value"
                >{{ value}}</option>
              </select>
            </div>
          </div>
        </form>
      </div>

      <div class="card-footer">
        <div class="action-button-wrapper">
          <div class="action-button">
            <button
              type="submit"
              class="btn btn-success btn-sm btn-100"
              form="register-patient-form"
              v-on:click="registerOrUpdatePatient"
              ref="registerButton"
            >
              <template v-if="isUpdate">Update</template>
              <template v-else>Register</template>
            </button>
            <button
              type="button"
              class="btn btn-blue btn-sm btn-100"
              form="register-patient-form"
              v-on:click="registerOrUpdatePatientAndEnterTestData"
              ref="registerAndTestResultButton"
              title="Register/Update and enter test results"
            >
              <template v-if="isUpdate">
                Update
                <font-awesome-icon title="Expand" icon="arrow-circle-right" />
              </template>
              <template v-else>
                Register
                <font-awesome-icon title="Expand" icon="arrow-circle-right" />
              </template>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-secondary btn-100"
              v-on:click="clearAll(true)"
              ref="clearAllButton"
            >Clear All</button>
            <!-- <template v-if="isUpdate">
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                v-on:click="enterTestResults()"
                ref="enterTestResultsButton"
              >Enter Test Results</button>
            </template>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TestSnippet from "@/components/TestSnippet.vue";
import moment from "moment";
import axios from "axios";
import Utils from "@/utils.js";
import { EventBus } from "@/global-event-bus.js";
import {
  EVENT_PATIENT_DELETE_TEST,
  EVENT_SEARCHING_PATIENT_STATUS
} from "@/event-constants.js";

("use strict");

export default {
  name: "RegisterPatient",
  components: {
    TestSnippet
  },
  data() {
    return {
      form: null,
      testId: null,
      genderSelectionDisabled: false,
      titles: ["Mr.", "Mrs.", "Ms.", "Miss.", "Baby.", "Rev.", "Master.", "Dr."],
      tests: [],
      patient: {
        id: null,
        patientId: null,
        title: null,
        firstName: null,
        lastName: null,
        age: null,
        gender: null,
        sampleCollectedOn: moment().format("YYYY-MM-DD"),
        requestedBy: null,
        collectionCenter: null,
        ward: null,
        contactNumber: null,
        nic: null,
        address: null,
        tests: []
      },
      selectedTests: [],
      allRequestedBy: [],
      allCollectionCenters: [],
      isUpdate: false,
      componentRefsToDisableAtBusy: [
        "registerButton",
        "clearAllButton",
        "enterTestResultsButton",
        "registerAndTestResultButton"
        // "additionalInformationButton"
      ]
    };
  },

  watch: {
    "patient.title": function(val) {
      this.genderSelectionDisabled = true;
      if (val === "Mr.") {
        this.patient.gender = "M";
      } else if (val === "Mrs." || val === "Ms.") {
        this.patient.gender = "F";
      } else {
        this.patient.gender = "";
        this.genderSelectionDisabled = false;
      }
    },

    "patient.tests": function(val) {
      var testIds = val.map(t => t.id);
      var selectedTests = this.tests.filter(
        test => testIds.indexOf(test.id) >= 0
      );
      selectedTests.sort((a, b) => a.testName.localeCompare(b.testName));

      this.selectedTests = [];
      this.selectedTests.push.apply(this.selectedTests, selectedTests);
    }
  },

  mounted() {
    const today = moment().format("YYYY-MM-DD");
    this.$refs["sampleCollectedOn"].setAttribute("max", today);
    this.form = document.getElementById("register-patient-form");
    var patientId = this.$route.query.patientId;

    if (patientId != undefined) {
      this.patient.patientId = patientId;
      this.isUpdate = true;

      this.getExistingPatientInformation();
    }
  },

  created() {
    EventBus.$on(EVENT_PATIENT_DELETE_TEST, this.deletePatientTest);
    this.clearAll(false);
    // this.loadTests();
    this.tests = this.$store.getters.tests;

    this.allRequestedBy = this.$store.getters.requestedByDoctors;
    this.allCollectionCenters = this.$store.getters.collectionCenters;
  },

  beforeDestroy() {
    EventBus.$off(EVENT_PATIENT_DELETE_TEST, this.deletePatientTest);
  },

  methods: {
    addToPatientTests: function() {
      if (this.testId != null) {
        var testAlreadyAdded =
          this.patient.tests.filter(t => t.id === this.testId).length > 0;

        if (!testAlreadyAdded) {
          this.patient.tests.push({
            id: this.testId
          });
        }
      }
    },

    deletePatientTest: function(testId) {
      var index = this.patient.tests.findIndex(function(test) {
        return test.id == testId;
      });
      this.patient.tests.splice(index, 1);
    },

    clearAll(withConfirmation) {
      if (withConfirmation) {
        var response = confirm("Are you sure you want to clear all?");
        if (response == false) {
          return;
        }
      }
      this.testId = null; // selected test
      this.genderSelectionDisabled = false;
      Object.keys(this.patient).forEach(key => (this.patient[key] = null)); // clear all patient attributes
      this.patient.sampleCollectedOn = moment().format("YYYY-MM-DD");
      this.patient.tests = [];
    },

    registerOrUpdatePatient(loadTestResults = false) {
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      // there needs to be at least one test
      if (this.patient.tests.length == 0) {
        Utils.notifyError("Please select tests.");
        return;
      }

      var filteredData = {};
      Object.keys(this.patient)
        .filter(key => this.patient[key] != null)
        .forEach(key => (filteredData[key] = this.patient[key]));

      const loading = Utils.busy(this, true, this.componentRefsToDisableAtBusy);

      var endpoint = "/patient/add";

      if (this.isUpdate) {
        endpoint = "/patient/update";
      }

      axios
        .post(Utils.getURL(endpoint), filteredData)
        .then(response => {
          Utils.unbusy(this, loading, true, this.componentRefsToDisableAtBusy);

          Utils.notifySuccess(response);

          const pId = ((response.data || {}).data || {}).patientId || null;
          if (pId) {
            this.patient.patientId = pId;
          }

          if (loadTestResults == true) {
            this.enterTestResults();
          } else {
            if (!this.isUpdate) {
              this.clearAll();
            }
          }
        })
        .catch(error => {
          Utils.unbusy(this, loading, true, this.componentRefsToDisableAtBusy);

          Utils.notifyError(error);

          if (this.isUpdate) {
            this.getExistingPatientInformation();
          }
        });
    },

    getExistingPatientInformation() {
      // retrieve patient Information
      const loading = Utils.busy(this, true, this.componentRefsToDisableAtBusy);

      axios
        .get(
          Utils.getURL("/patient/getPatientById/" + this.patient.patientId),
          {
            params: {
              isDetailed: true
            }
          }
        )
        .then(response => {
          Utils.unbusy(this, loading, true, this.componentRefsToDisableAtBusy);

          var data = response.data.results[0];

          var tests = data.tests;
          delete data.tests;
          delete data.test_results;

          Object.keys(data).forEach(key => {
            this.patient[key] = data[key];
          });

          this.patient.tests = [];

          tests.forEach(test => {
            this.patient.tests.push(test);
          });
        })
        .catch(error => {
          Utils.unbusy(this, loading, true, this.componentRefsToDisableAtBusy);

          Utils.notifyError(error);
        });
    },

    enterTestResults() {
      this.$router.push({
        name: "test-result",
        query: {
          patientId: this.patient.patientId
        }
      });

      EventBus.$emit(EVENT_SEARCHING_PATIENT_STATUS, { PARAM_SEARCHING: true });
    },

    registerOrUpdatePatientAndEnterTestData() {
      this.registerOrUpdatePatient(true);
    }
  },

  computed: {
    sortedTitles: function() {
      return this.titles.sort();
    },

    isReadOnly: function() {
      return this.isUpdate;
    }
  }
};
</script>

<style scoped>
.action-button-wrapper {
  display: flex;
  justify-content: flex-end;
}

.action-button {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.action-button button {
  margin-left: 20px;
}
</style>
